
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// /Users/shakyshane/Sites/oss/UI/~/component-inherit/index.js
// module id = 48
// module chunks = 0